import { Button, Spinner, Text, tokens } from '@fluentui/react-components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { backfillZoneCoordinates } from '../../api/terrain.api';
import { usePermission } from '../../hooks/usePermission';
import { useT } from '../../i18n';

/** Calcula lat/lng (centro de la geocerca) de los lotes y zonas de la empresa que aún no la tienen. */
export function ZoneCoordinatesSection() {
  const t = useT().settings;
  const qc = useQueryClient();
  const canWrite = usePermission('lotes:write');
  const run = useMutation({
    mutationFn: backfillZoneCoordinates,
    onSuccess: () => {
      for (const key of ['lotes-map', 'modules-map-at-date', 'investor-modules']) qc.invalidateQueries({ queryKey: [key] });
    },
  });

  const result = run.data;
  const message = !result ? null : (result.lotes.updated + result.modules.updated > 0 ? t.zoneCoordsDone : t.zoneCoordsNothing)
    .replace('{lotes}', String(result.lotes.updated))
    .replace('{modules}', String(result.modules.updated))
    .replace('{noBoundary}', String(result.lotes.noBoundary + result.modules.noBoundary));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <Text weight="semibold" style={{ fontSize: 12 }}>{t.zoneCoordsTitle}</Text>
      <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>{t.zoneCoordsHint}</Text>
      <div>
        <Button
          size="small"
          disabled={!canWrite || run.isPending}
          icon={run.isPending ? <Spinner size="tiny" /> : undefined}
          onClick={() => run.mutate()}
        >
          {run.isPending ? t.zoneCoordsRunning : t.zoneCoordsBtn}
        </Button>
      </div>
      {message && <Text size={200} role="status">{message}</Text>}
      {run.isError && <Text size={200} role="alert" style={{ color: tokens.colorPaletteRedForeground1 }}>{t.zoneCoordsError}</Text>}
    </div>
  );
}
